(() => {
  function stripCentsFromPrice(priceText) {
    const clean = (priceText || '').trim();
    if (!clean) return '';
    return clean.replace(/([.,])\d{2}(?!\d)/, '');
  }

  function formatCoatTablePrice(priceText) {
    const withoutCents = stripCentsFromPrice(priceText);
    if (!withoutCents) return '';
    return withoutCents.startsWith('~') ? withoutCents : `~${withoutCents}`;
  }

  function updatePdpTableCoatPrices() {
    const priceTargets = document.querySelectorAll('[data-pdp-table-dynamic-coat-price]');
    if (!priceTargets.length) return;

    const selectedBundleItem = document.querySelector('.product-bundle-variants__item.is-selected');
    const selectedBundlePrice =
      selectedBundleItem?.querySelector('[data-bundle-price]') ||
      selectedBundleItem?.querySelector('.product-bundle-variants__price');
    const buyButtonPrice = document.querySelector('[data-buy-button-price]');
    const stickyPrice = document.querySelector('[data-sticky-atc-price]');
    const salePrice = document.querySelector('.price-list--product sale-price');

    const nextPrice =
      selectedBundlePrice?.textContent?.trim() ||
      buyButtonPrice?.textContent?.trim() ||
      stickyPrice?.textContent?.trim() ||
      salePrice?.textContent?.trim() ||
      '';

    if (!nextPrice) return;

    const formatted = formatCoatTablePrice(nextPrice);
    priceTargets.forEach((target) => {
      target.textContent = formatted;
    });
  }

  function getVisibleScrollTarget() {
    const candidates = [
      document.querySelector('bundle-variants-switcher'),
      document.querySelector(
        'safe-sticky.product-info .product-info__block-item[data-block-type="buy-buttons"], .product-info .product-info__block-item[data-block-type="buy-buttons"]'
      ),
      document.querySelector(
        '.product-info__block-item[data-block-type="buy-buttons"], .product-info__block-item[data-block-id="buy_buttons"]'
      ),
      document.querySelector('#main-product--new, .product-section--new')
    ].filter(Boolean);

    return (
      candidates.find((el) => {
        const style = window.getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
      }) || null
    );
  }

  function readCssPx(name) {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    const value = parseFloat(raw);
    return Number.isFinite(value) ? value : 0;
  }

  function getStickyHeaderOffset() {
    const rootStyles = getComputedStyle(document.documentElement);
    const headerSticky = rootStyles.getPropertyValue('--header-is-sticky').trim() !== '0';
    const headerVisible = rootStyles.getPropertyValue('--header-is-visible').trim() !== '0';
    const announcementSticky = rootStyles.getPropertyValue('--announcement-bar-is-sticky').trim() !== '0';

    let offset = 0;
    if (headerSticky && headerVisible) offset += readCssPx('--header-height');
    if (announcementSticky) offset += readCssPx('--announcement-bar-height');

    if (offset > 0) return offset;

    const stuck = Array.prototype.slice
      .call(document.querySelectorAll('sticky-header, .announcement-bar, #header, .header'))
      .filter((el) => {
        const style = window.getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        const isStuck = style.position === 'sticky' || style.position === 'fixed';
        return isStuck && rect.top <= 1 && rect.bottom > 0 && rect.height > 0;
      });

    if (stuck.length) {
      return Math.max.apply(
        null,
        stuck.map((el) => el.getBoundingClientRect().bottom)
      );
    }

    const header =
      document.querySelector('sticky-header') ||
      document.querySelector('#header') ||
      document.querySelector('.header');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function smoothScrollTo(targetY, duration = 850) {
    const startY = window.pageYOffset || document.documentElement.scrollTop || 0;
    const endY = Math.max(0, targetY);
    const distance = endY - startY;

    if (Math.abs(distance) < 1) return;

    const html = document.documentElement;
    const previousBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, endY);
      html.style.scrollBehavior = previousBehavior;
      return;
    }

    const startTime = performance.now();
    const easeInOutCubic = (t) =>
      t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

    const step = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      window.scrollTo(0, startY + distance * easeInOutCubic(progress));
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        window.scrollTo(0, endY);
        html.style.scrollBehavior = previousBehavior;
      }
    };

    requestAnimationFrame(step);
  }

  function bindPdpTableScrollHints() {
    document.querySelectorAll('[data-pdp-table-scroller]').forEach((scroller) => {
      if (scroller.dataset.scrollHintBound === 'true') return;
      scroller.dataset.scrollHintBound = 'true';

      const wrap = scroller.querySelector('.pdp-table__table-wrap');
      const table = scroller.querySelector('.pdp-table__table');
      if (!wrap) return;

      const updateOverflow = () => {
        const maxScroll = wrap.scrollWidth - wrap.clientWidth;
        const hasOverflow = maxScroll > 2;
        const atEnd = !hasOverflow || wrap.scrollLeft >= maxScroll - 2;

        scroller.classList.toggle('is-overflowing', hasOverflow);
        scroller.classList.toggle('is-overflow-end', hasOverflow && !atEnd);
        scroller.classList.toggle('is-at-end', atEnd);
      };

      wrap.addEventListener('scroll', updateOverflow, { passive: true });
      window.addEventListener('resize', updateOverflow);
      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(updateOverflow);
        observer.observe(wrap);
        if (table) observer.observe(table);
      }
      requestAnimationFrame(() => requestAnimationFrame(updateOverflow));
    });
  }

  function bindPdpTableButtons() {
    const buttons = document.querySelectorAll('.pdp-table__button');

    buttons.forEach((button) => {
      if (button.dataset.scrollToCartBound === 'true') return;

      button.dataset.scrollToCartBound = 'true';
      button.addEventListener('click', (event) => {
        const href = (button.getAttribute('href') || '').trim();
        const isScrollTrigger =
          button.hasAttribute('data-scroll-to-cart-trigger') || href === '' || href === '#';

        if (!isScrollTrigger) return;

        event.preventDefault();
        event.stopPropagation();

        const target = getVisibleScrollTarget();
        if (!target) return;

        const top =
          window.pageYOffset +
          target.getBoundingClientRect().top -
          getStickyHeaderOffset() -
          24;

        smoothScrollTo(top);
      });
    });
  }

  document.addEventListener('bundle:variant-change', updatePdpTableCoatPrices);
  document.addEventListener('bundle:after-switch', updatePdpTableCoatPrices);
  document.addEventListener('variant:change', updatePdpTableCoatPrices);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updatePdpTableCoatPrices();
      bindPdpTableButtons();
      bindPdpTableScrollHints();
    });
  } else {
    updatePdpTableCoatPrices();
    bindPdpTableButtons();
    bindPdpTableScrollHints();
  }
})();
